const showHidePwd = () => {
    document.querySelectorAll('.js-show-hide-pwd').forEach((button) => {
        button.addEventListener('click', () => {
            const buttonWrapper = button.closest('.js-pwd-wrapper');
            const pwdInput = buttonWrapper === null || buttonWrapper === void 0 ? void 0 : buttonWrapper.querySelector('.js-pwd-input');
            if (pwdInput) {
                button.classList.toggle('active');
                pwdInput.type = button.classList.contains('active') ? 'text' : 'password';
            }
        });
    });
};
export default showHidePwd;
